import L from "leaflet"

export class MapRenderer {
  constructor(map) {
    this.map = map;
    this.renderedNodeIds = new Set();
    this.renderedNodes = new Map();
    this.markers = new Map();
  }

  renderData(items) {
    if (!items) return;

    for (const i in items) {
      const node = items[i];
      const id = node.id;

      const cachedNode = this.renderedNodes.get(id);

      if (cachedNode && this.nodesAreEqual(cachedNode, node)) { 
        continue; // No changes, skip redraw
      }

      // Update cache
      this.renderedNodes.set(id, { lat: node.lat, lon: node.lon, tags: node.tags });

      // Remove existing marker if it exists (optional)
      if (this.markers.has(id)) {
        this.map.removeLayer(this.markers.get(id));
      }

      // Create new icon and marker
      const icon = L.divIcon({
        className: 'custom-popup-icon',
        html: node.iconSvg,
        iconSize: [30, 30],
        iconAnchor: [15, 30], // bottom middle
        popupAnchor: [0, -30],
      });

      const marker = L.marker([node.lat, node.lon], { icon });
      let content = node.html || `<div class="d-flex flex-column"><div><h4>${node.name || "Unnamed"}</h4></div>`;      
      marker.bindPopup(content);

      this.map.on('popupopen', function(e) {
        this.setView(e.popup.getLatLng());
      });

      marker.addTo(this.map);
      this.markers.set(id, marker); // Store the new marker
    }
  }

  renderPreviewLocation(center) {
    const currentIcon = L.divIcon({
      className: 'custom-svg-icon',
      html: this.iconCurrentLocation(),
      iconSize: [24, 24]
    });

    const markers = new L.FeatureGroup();
    markers.addLayer(L.marker(center, { icon: currentIcon }));
    this.map.addLayer(markers);
  }

  removeMarker(id) {
    if (this.markers.has(id)) {
      this.map.removeLayer(this.markers.get(id));
      this.markers.delete(id);
    }
    this.renderedNodes.delete(id);
  }

  nodesAreEqual(a, b) {
    return (
      a.lat === b.lat &&
      a.lon === b.lon &&
      JSON.stringify(a.tags || {}) === JSON.stringify(b.tags || {})
    );
  }

  iconCurrentLocation() {
    return '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="#2A93EE"  class="icon icon-tabler icons-tabler-filled icon-tabler-circle-dot"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 6.66a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z" /></svg>';
  }
}
